"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateThemesCSSFromContent = void 0;
var types_1 = require("../types");
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
// TODO: Использовать этот метод вместо generateThemesCSS
var generateThemesCSSFromContent = function (theme) {
    var files = [];
    for (var _i = 0, _a = Object.entries(theme); _i < _a.length; _i++) {
        var _b = _a[_i], fileName = _b[0], content = _b[1];
        var lightTheme = "".concat(fileName, "__").concat(types_1.ColorMode.LIGHT);
        var darkTheme = "".concat(fileName, "__").concat(types_1.ColorMode.DARK);
        var moduleTheme = "".concat(fileName, ".module");
        var colorsDarkContent = "".concat((0, utils_1.jsToCss)(content.dark, ':root'), "\n");
        var colorsLightContent = "".concat((0, utils_1.jsToCss)(content.light, ':root'), "\n");
        var colorModuleContent = "".concat([(0, utils_1.jsToCss)(content.dark, ':root'), (0, utils_1.jsToCss)(content.light, ':root')]
            .join('\n')
            .replace(':root', ".".concat(types_1.ColorMode.DARK))
            .replace(':root', ".".concat(types_1.ColorMode.LIGHT)), "\n");
        var typoContent = "\n".concat(content.typo.filter(Boolean).join('\n\n'), "\n");
        var typoModuleContent = "\n".concat(content.typo
            .filter(Boolean)
            .join('\n\n')
            .replace(/:root/gim, ".".concat(types_1.ColorMode.LIGHT, ",\n  .").concat(types_1.ColorMode.DARK)), "\n");
        files.push((0, generateFile_1.generateCommonFile)(lightTheme, 'css', "".concat(colorsLightContent + typoContent)), (0, generateFile_1.generateCommonFile)(darkTheme, 'css', "".concat(colorsDarkContent + typoContent)), (0, generateFile_1.generateCommonFile)(moduleTheme, 'css', "".concat(colorModuleContent + typoModuleContent)));
    }
    return files;
};
exports.generateThemesCSSFromContent = generateThemesCSSFromContent;
//# sourceMappingURL=generateThemesCSSFromContent.js.map